import FooterUberTaxi from "../components/FooterUberTaxi";
import styles from "./policy.module.css";

export default function PrivacyPolicy() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const lastUpdated = "2026-03-03";

  return (
    <div className={styles.policyPage}>
      <header className={styles.header}>
        <div className={styles.wrap}>
          <h1 className={styles.title}>隱私權政策</h1>
          <div className={styles.meta}>
            <span>派車平台（台灣法規強化版）</span>
            <span className={styles.badge}>個人資料保護法</span>
          </div>

          <div className={styles.highlight}>
            本政策目前提供繁體中文版本，說明本平台蒐集、處理與利用個人資料的方式與您的權利。
          </div>

          <div className={styles.tocCard} aria-label="目錄">
            <div className={styles.toc}>
              <a href="#scope">一、適用範圍</a>
              <a href="#notice">二、個人資料蒐集告知事項（個資法第8條）</a>
              <a href="#purpose">三、資料使用目的</a>
              <a href="#line-login">四、LINE Login 與社群登入</a>
              <a href="#payments">五、金流與交易資料</a>
              <a href="#cookies">六、Cookie 與技術資料</a>
              <a href="#security">七、資料安全措施</a>
              <a href="#rights">八、當事人權利（個資法第3條）</a>
              <a href="#impact">九、不提供資料之影響</a>
              <a href="#minors">十、未成年人保護</a>
              <a href="#thirdparty">十一、第三方服務</a>
              <a href="#crossborder">十二、跨境資料傳輸</a>
              <a href="#updates">十三、政策修訂</a>
              <a href="#contact">十四、聯絡資訊</a>
            </div>
          </div>
        </div>
      </header>

      <main className={`${styles.wrap} ${styles.main}`}>
        <section id="scope" className={styles.section}>
          <h2>一、適用範圍</h2>
          <p>本隱私權政策適用於本平台（以下稱「本公司」）所提供之網站、行動應用程式、LINE 官方帳號及相關派車／叫車服務。</p>
          <p>當您使用本服務時，即表示您同意本政策內容。</p>
        </section>

        <section id="notice" className={styles.section}>
          <h2>二、個人資料蒐集告知事項（依個人資料保護法第 8 條）</h2>

          <h3>（一）蒐集機關名稱</h3>
          <p>公司名稱：<span className={styles.codeText}>好朋友租賃</span></p>

          <h3>（二）蒐集目的</h3>
          <p>依據法務部公告之特定目的項目，本公司蒐集個人資料之目的包含：</p>
          <ul>
            <li>090 消費者、客戶管理與服務</li>
            <li>063 非公務機關依法定義務所進行個人資料之蒐集處理及利用</li>
            <li>069 契約、類似契約或其他法律關係事務</li>
            <li>135 資（通）訊服務</li>
            <li>136 資（通）訊與資料庫管理</li>
            <li>157 調查、統計與研究分析</li>
            <li>040 行銷（如您同意或法律允許之範圍）</li>
          </ul>

          <h3>（三）蒐集之個人資料類別</h3>
          <p>依個資法分類，可能包括（依您使用之功能而定）：</p>
          <ul>
            <li>C001 辨識個人者（姓名、電話、Email、LINE ID 等）</li>
            <li>C003 政府資料中之辨識者（如開立發票所需資訊，依實際需求）</li>
            <li>C011 個人描述（例如偏好、備註）</li>
            <li>C021 家庭情形（如緊急聯絡人，若您主動提供）</li>
            <li>C031 住家及設施（如地址，依服務需要）</li>
            <li>C038 職業（如司機／車隊資料）</li>
            <li>C061 現行之受僱情形（如司機或合作夥伴資格審核）</li>
            <li>C093 財務交易資料（例如交易時間、金額、付款方式；不含完整卡號）</li>
            <li>C132 未分類資料（行程備註、客服對話等）</li>
          </ul>

          <h3>（四）個人資料利用期間</h3>
          <ul>
            <li>服務存續期間內</li>
            <li>法令規定保存期間</li>
            <li>契約履行期間</li>
            <li>爭議處理期間</li>
          </ul>

          <h3>（五）利用地區</h3>
          <ul>
            <li>中華民國（台灣）境內</li>
            <li>或經您同意／依法律允許之境外地區（例如使用雲端服務）</li>
          </ul>

          <h3>（六）利用對象</h3>
          <ul>
            <li>本公司</li>
            <li>合作車隊、司機或運輸合作夥伴（僅限完成行程所必要之資訊）</li>
            <li>金流服務商（交易處理所必要資訊）</li>
            <li>雲端與系統服務供應商（維運與資安所必要資訊）</li>
            <li>政府機關依法要求時</li>
          </ul>

          <h3>（七）利用方式</h3>
          <ul>
            <li>書面、電子文件</li>
            <li>自動化系統處理</li>
            <li>網際網路傳輸</li>
          </ul>
        </section>

        <section id="purpose" className={styles.section}>
          <h2>三、資料使用目的</h2>
          <p>本公司蒐集與利用個人資料之目的包括：</p>
          <ul>
            <li>行程安排與派車服務</li>
            <li>訂單處理、客服與聯繫</li>
            <li>身分驗證、安全管理、風險控管與防詐</li>
            <li>付款處理、對帳與帳務管理</li>
            <li>服務改善、系統除錯與分析</li>
            <li>行銷推廣與通知（可隨時取消／拒絕）</li>
            <li>遵守法律規定或配合主管機關要求</li>
          </ul>

          <div className={styles.noteCard}>
            <p><b>定位資料</b></p>
            <p>
              本平台目前<strong>不蒐集您的即時定位資料</strong>（例如 GPS 背景定位）。
              行程所需之上下車地點等資訊，將以您在訂單中<strong>自行輸入</strong>或選取之內容為準。
            </p>
          </div>
        </section>

        <section id="line-login" className={styles.section}>
          <h2>四、LINE Login 與社群登入</h2>
          <p>
            本平台提供 <b>LINE Login</b> 以利您快速登入與使用服務。當您選擇使用 LINE Login 時，
            本公司可能取得您授權提供之資料（例如：LINE 使用者識別碼、顯示名稱、頭像、Email（如您授權）等），
            並僅用於帳號建立、登入驗證、服務通知與客服支援等目的。
          </p>
          <p>您可於 LINE 或裝置端調整授權範圍或取消授權；取消授權後，部分登入或通知功能可能受影響。</p>
        </section>

        <section id="payments" className={styles.section}>
          <h2>五、金流與交易資料</h2>
          <p>
            本平台提供第三方金流服務以完成付款與交易。為完成交易，本公司可能處理必要之交易資訊，例如：
            訂單編號、交易時間、金額、付款方式、付款狀態等。
          </p>
          <p><b>信用卡資料由第三方金流服務商處理</b>，本平台不保存完整卡號或安全碼等敏感資訊。</p>
        </section>

        <section id="cookies" className={styles.section}>
          <h2>六、Cookie 與技術資料</h2>
          <p>本平台可能使用 Cookie 或類似技術以提升使用體驗、分析流量與服務優化。您可於瀏覽器設定中停用 Cookie，但可能導致部分功能無法正常運作。</p>
        </section>

        <section id="security" className={styles.section}>
          <h2>七、資料安全措施</h2>
          <p>本公司採取合理之技術與管理措施以保護您的資料安全，包括但不限於：</p>
          <ul>
            <li>SSL/TLS 加密傳輸</li>
            <li>權限分級與存取控管</li>
            <li>防火牆與入侵防護</li>
            <li>系統日誌與異常監控</li>
            <li>必要之備援與復原機制</li>
          </ul>
        </section>

        <section id="rights" className={styles.section}>
          <h2>八、當事人權利（依個資法第 3 條）</h2>
          <p>您得向本公司就您的個人資料行使下列權利：</p>
          <ul>
            <li>查詢或請求閱覽</li>
            <li>請求製給複製本</li>
            <li>請求補充或更正</li>
            <li>請求停止蒐集、處理或利用</li>
            <li>請求刪除</li>
          </ul>
          <p>
            申請方式：請來信至 <a href="mailto:bevis.tw@gmail.com">bevis.tw@gmail.com</a> 並提供可供核驗之必要資訊。
            為保護您的帳號安全，本公司可能要求進一步驗證身分。
          </p>
        </section>

        <section id="impact" className={styles.section}>
          <h2>九、不提供資料之影響</h2>
          <p>若您拒絕提供服務所必要之個人資料，本公司可能無法提供部分或全部服務（例如無法完成訂單、派車或客服聯繫）。</p>
        </section>

        <section id="minors" className={styles.section}>
          <h2>十、未成年人保護</h2>
          <p>若您為未滿 20 歲之使用者，應由法定代理人閱讀並同意本政策後，再使用本服務。</p>
        </section>

        <section id="thirdparty" className={styles.section}>
          <h2>十一、第三方服務</h2>
          <p>本平台可能整合或使用第三方服務（依實際上線功能而定），例如：</p>
          <ul>
            <li>LINE Login / LINE 通知服務</li>
            <li>第三方金流服務（信用卡／轉帳／電子支付等）</li>
            <li>地圖服務（如您使用地址選取或路線展示功能時，可能涉及地圖供應商）</li>
            <li>雲端主機、儲存、監控與分析服務</li>
          </ul>
          <p>第三方服務供應商將依其隱私權政策處理資料，本公司建議您另行參考其公告內容。</p>
        </section>

        <section id="crossborder" className={styles.section}>
          <h2>十二、跨境資料傳輸</h2>
          <p>
            若本平台使用境外雲端主機或第三方服務，可能涉及個人資料跨境傳輸。本公司將依個資法及主管機關相關規定，
            採取適當保護措施（例如存取控管、加密、委外契約約束等）。
          </p>
        </section>

        <section id="updates" className={styles.section}>
          <h2>十三、政策修訂</h2>
          <p>本公司保留隨時修訂本政策之權利。修訂後將公告於本平台，並自公告日起生效。</p>
        </section>

        <section id="contact" className={styles.section}>
          <h2>十四、聯絡資訊</h2>
          <ul>
            <li>公司名稱：<span className={styles.codeText}>好朋友小客車租賃有限公司</span></li>
            <li>統一編號：<span className={styles.codeText}>66367788</span></li>
            <li>聯絡信箱：<a href="mailto:bevis.tw@gmail.com">bevis.tw@gmail.com</a></li>
            <li>地址：<span className={styles.codeText}>新北市板橋區溪崑一街29號(2樓)</span></li>
          </ul>

          <div className={styles.noteCard}>
            <p><b>（選配條款）事故處理與保險資料</b></p>
            <p>
              若發生行程爭議或事故，本公司可能在必要範圍內蒐集與提供相關資料（例如訂單資訊、聯繫紀錄、客服對話紀錄、付款狀態等）
              予合作車隊、保險公司或主管機關，以協助釐清事件與進行理賠或法律程序。
            </p>
          </div>
        </section>
      </main>

      <footer className={styles.pageFooter}>
        <div className={styles.wrap}>
          <div>© {currentYear} 好朋友小客車租賃有限公司｜All rights reserved.</div>
          <div>最後更新日期：<span className={styles.codeText}>{lastUpdated}</span></div>
        </div>
      </footer>
      <FooterUberTaxi />
    </div>
  );
}
